import { toggleVisibility, visibleClass, activeClass } from './helpers'

export function tabs() {
	const isTouch = window.matchMedia('(pointer: coarse)').matches

	function tabHandler(tab) {
		// Do nothing if the current tab already has the active class
		if (tab.classList.contains(activeClass)) {
			return
		}

		const tabsParent = tab.closest('[data-tabs]')

		// Remove active state from the current active tab
		const activeTab = tabsParent.querySelector('[data-tab].' + activeClass)
		activeTab.classList.remove(activeClass)
		activeTab.setAttribute('aria-selected', 'false')

		// Set the new active tab
		tab.classList.add(activeClass)
		tab.setAttribute('aria-selected', 'true')

		// Toggle tab panels visibility
		const visibleTabPanel = tabsParent.querySelector(`.${visibleClass}`)
		toggleVisibility(visibleTabPanel)
		const targetTabPanel = document.getElementById(tab.getAttribute('aria-controls'))
		toggleVisibility(targetTabPanel)

		// Scroll to the active tab on mobile within the scrollbar
		const tabList = tabsParent.querySelector('[data-tablist]')
		const tabListStyles = window.getComputedStyle(tabList)
		const tabListStylesLeftOffset = parseInt(tabListStyles.paddingLeft, 10)
		const scrollLeft = tab.getBoundingClientRect().left - tabListStylesLeftOffset
		tabList.scrollLeft += scrollLeft
	}

	// Find all tab elements
	const tabs = document.querySelectorAll('[data-tab]')
	tabs.forEach(tab => {
		const tabsParent = tab.closest('[data-tabs]')
		const tabsHover = tabsParent?.hasAttribute('data-tabs-hover')

		if (!isTouch && tabsHover) {
			tab.addEventListener('mouseenter', () => tabHandler(tab))
		} else {
			tab.addEventListener('click', (e) => {
				e.preventDefault()
				tabHandler(tab)
			})
		}
	})
}
